<template>
    <DefaultHeader />

    <div class="missions-page">
        <div class="container py-3 py-md-4">

            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <CurrentMissions />
                </div>
            </div>
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <PendingMissions />
                </div>
            </div>
        </div>

    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import CurrentMissions from './Sections/CurrentMissions.vue'
import PendingMissions from './Sections/PendingMissions.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        CurrentMissions,
        PendingMissions,
    },
}
</script>


<style scoped>
.missions-page {
    background: #f3f6fa;
    min-height: 100%;
}
</style>